import React, { useMemo } from 'react';
import type { RefObject } from 'react';
import type { CanvasPlugin } from '../../../core/canvas/CanvasPlugin';
import type { CommandManager } from '../../../core/commands/CommandManager';
import type { DiagramType } from '../../../core/tools/interfaces/ITool';
import type { ToolRegistry } from '../../../core/tools/ToolRegistry';

export const CanvasPluginHosts: React.FC<{
  canvasPlugins: readonly CanvasPlugin[];
  toolRegistry: ToolRegistry;
  effectiveDiagramType: DiagramType;
  commandManager: CommandManager;
  doc: unknown;
  frames: readonly unknown[];
  stageRef: RefObject<any>;
  layerRef: RefObject<any>;
  pluginHostStateById: Record<string, unknown>;
  setPluginHostState: (pluginId: string, next: unknown) => void;
}> = ({
  canvasPlugins,
  toolRegistry,
  effectiveDiagramType,
  commandManager,
  doc,
  frames,
  stageRef,
  layerRef,
  pluginHostStateById,
  setPluginHostState,
}) => {
  const setHostStateByPluginId = useMemo(() => {
    const map: Record<string, (next: unknown) => void> = {};
    for (const plugin of canvasPlugins) {
      const pluginId = plugin.id;
      map[pluginId] = (next: unknown) => setPluginHostState(pluginId, next);
    }
    return map;
  }, [canvasPlugins, setPluginHostState]);

  return (
    <>
      {canvasPlugins.map((plugin) => {
        const node = plugin.renderHost?.({
          context: { toolRegistry, diagramType: effectiveDiagramType, commandManager, doc: doc ?? undefined },
          frames,
          stageRef,
          layerRef,
          hostState: pluginHostStateById[plugin.id],
          setHostState: setHostStateByPluginId[plugin.id] ?? ((next) => setPluginHostState(plugin.id, next)),
        });
        return node ? <React.Fragment key={plugin.id}>{node}</React.Fragment> : null;
      })}
    </>
  );
};
